import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Checkbox from '../Checkbox';
import Table from '../Table';

export default function ConcurentPlatformsDialog({
  openConcurentPlatformsDialog,
  setOpenConcurentPlatformsDialog,
  suppliersList = [],
  selectedPlatforms = '',
  onSave
}) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // 🔹 Synchronizacja przy otwarciu dialogu lub zmianie danych
 useEffect(() => {
    if (!openConcurentPlatformsDialog) {
      setSelectedIds([]);
      setSelectAll(false);
      return;
    }

    // if (selectedSuppliers === '*') {
    //   setSelectedIds(suppliersList.map(s => String(s.id)));
    //   setSelectAll(true);
    // } else 
        if (selectedPlatforms) {
      const ids = selectedPlatforms.split(';').map(String);
      console.log("selectedPlatforms:", selectedPlatforms);
      setSelectedIds(ids);
      setSelectAll(ids.length === suppliersList.length);
    } else {
      setSelectedIds([]);
      setSelectAll(false);
    }
  }, [openConcurentPlatformsDialog, selectedPlatforms, suppliersList]);
  // 🔹 Toggle pojedynczego dostawcy
    const toggleSupplier = (id) => {
    setSelectedIds(prev => {
      const newSelected = prev.includes(String(id))
        ? prev.filter(x => x !== String(id))
        : [...prev, String(id)];

      setSelectAll(newSelected.length === suppliersList.length);
      return newSelected;
    });
  };

  // 🔹 Toggle wszystkich
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
      setSelectAll(false);
    } else {
      setSelectedIds(suppliersList.map(s => String(s.id)));
      setSelectAll(true);
    }
  };

  // 🔹 Zapis
   const handleSave = () => {
    const result = selectedIds.join(';');
    onSave(result);
    setOpenConcurentPlatformsDialog(false);
  };

   const columns = [
     {
       field: 'select',
       headerName: '',
       width: 40,
       renderCell: ({ row }) => (
         <Checkbox
         checked={selectedIds.includes(String(row.id))}
             onCheckedChange={() => toggleSupplier(row.id)}
           size="small"
         />
       ),
     },
     {
       field: 'int_name',
       headerName: 'Nazwa platformy',
       renderCell: ({ row }) => (
         <div
           onClick={() => toggleSupplier(row.id)}
           className="cursor-pointer select-none hover:text-primary-600 transition-colors"
         >
           {row.Name}
         </div>
       ),
     }
   ];

  return (
     <Dialog
          open={openConcurentPlatformsDialog}
          onClose={() => setOpenConcurentPlatformsDialog(false)}
          width="max-w-xl"
        >
          <DialogTitle>Wybierz platformy konkurencji</DialogTitle>
          <DialogContent className="overflow-y-auto max-h-[70vh]">
            <div className="overflow-x-auto mt-2">
              {/* 🔹 Sekcja zaznacz wszystkich */}
              <div className="mb-4">
                <div className="flex items-center space-x-2">
                  <Checkbox checked={selectAll} onCheckedChange={toggleSelectAll} />
                  <span className="text-xs font-medium cursor-pointer" onClick={toggleSelectAll}>
                    Zaznacz wszystkich
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Zaznaczenie tej opcji wybierze wszystkie dostępne platformy.
                  Klikając na nazwę platformy możesz zmienić jego zaznaczenie.
                </p>
              </div>
    
              {/* 🔹 Tabela dostawców */}
              <Table columns={columns} data={suppliersList} />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              size="medium"
              variant="outlined"
              onClick={() => setOpenConcurentPlatformsDialog(false)}
            >
              Anuluj
            </Button>
            <Button
              size="medium"
              variant="contained"
              color="success"
              onClick={handleSave}
            >
              Zapisz
            </Button>
          </DialogActions>
        </Dialog>
    
  );
}
